import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-superadmin',
  templateUrl: './superadmin.component.html',
  styleUrls: ['./superadmin.component.scss']
})
export class SuperadminComponent implements OnInit {
  constructor() { }
  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/superadmin/superadmin.component.ts